import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showChampionshipStageForms } from 'modules/championship/store/championship/actions';
import { stagesActions } from 'modules/championship/store/stages';

/**
 * Закрывает форму этапа: гасит признак «форма открыта» и снимает выбор этапа.
 *
 * Признак живёт в сторе, а не в локальном состоянии экрана, потому что вкладка
 * «Этапы» показывает по нему подпись с названием этапа и возвращает к списку по
 * клику. Из-за этого сам он при уходе с экрана не исчезает — гасить надо руками,
 * иначе возврат на вкладку снова открывает форму ранее выбранного этапа
 * (IMGM-1398).
 *
 * `championshipId` необязателен: подпись вкладки строится и до того, как
 * соревнование загрузилось. Без id колбэк ничего не делает.
 */
export const useCloseStageForm = (championshipId?: number) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (championshipId === undefined) {
      return;
    }

    dispatch(stagesActions.stageSelected(null));
    dispatch(showChampionshipStageForms({ state: false, championshipId }));
  }, [dispatch, championshipId]);
};
